var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 9,
    viewBox: "0 0 239 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39645"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 31",
    x1: 9.5,
    y1: 4.5,
    x2: 229.5,
    y2: 4.5,
    stroke: "#239EFE",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    fill: "#239EFE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 234.5,
    cy: 4.5,
    r: 4.5,
    fill: "#239EFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolline);
export default __webpack_public_path__ + "static/media/volline.a2e54701b59fc277b0062b9c85997064.svg";
export { ForwardRef as ReactComponent };